export default __webpack_public_path__ + "static/media/Img5.de917f2b.jpg";